
import GoogleLogo from '@/assets/images/google_logo.svg?inline'
import LongArrowLeft from '@/assets/icons/fontawesome/light/long-arrow-left.svg?inline'
import LongArrowRight from '@/assets/icons/fontawesome/light/long-arrow-right.svg?inline'

export default {
  components: {
    GoogleLogo,
    LongArrowLeft,
    LongArrowRight,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      source: 'en',
      translating: false,
      translation: null,
      showTranslation: this.show,
    }
  },
  mounted() {
    if (this.show && this.$i18n.locale !== 'en') {
      this.translate()
    }
  },
  methods: {
    async translate() {
      this.$emit('translate')

      if (this.translation) {
        this.showTranslation = true

        return
      }

      this.translating = true

      try {
        await this.$axios
          .post('v3/services/translate', {
            target: this.$i18n.locale,
            q: this.content,
            format: 'text',
          })
          .then((response) => {
            if (response.data.data) {
              this.showTranslation = true
              this.translation =
                response.data.data.translations[0].translatedText
              this.source =
                response.data.data.translations[0].detectedSourceLanguage
            }
          })
      } catch (error) {}

      this.translating = false
    },
  },
}
